import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import React from "react"

import type { EditDialogMode } from "@/screens/ManageProducts/components/ProductClasses/types"
import { EditDialogModes } from "@/screens/ManageProducts/components/ProductClasses/types"

interface ClassificationActionsDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  onSelectEditMode: (mode: EditDialogMode) => void
}

const MENU_ICON_PROPS = {
  fontVariationSettings: '"wght" 300',
}

const ClassificationActionsDropdownMenu: React.FC<ClassificationActionsDropdownMenuProps> = ({
  anchorEl,
  onClose,
  onSelectEditMode,
}): ReactElement => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={true}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          className: "w-[260px]",
        },
      }}
    >
      <MenuItem onClick={() => onSelectEditMode(EditDialogModes.EditName)} data-test='edit-classification-name'>
        <ListItemIcon>
          <EditOutlined sx={MENU_ICON_PROPS} />
        </ListItemIcon>
        <ListItemText primary='Edit Class Name' />
      </MenuItem>
      <MenuItem onClick={() => onSelectEditMode(EditDialogModes.EditProductManager)} data-test='edit-product-manager'>
        <ListItemIcon>
          <EditOutlined sx={MENU_ICON_PROPS} />
        </ListItemIcon>
        <ListItemText primary='Change Product Manager' />
      </MenuItem>
    </Menu>
  )
}

export default ClassificationActionsDropdownMenu
